export const SOURCE_APPLICATION_NAME = 'discoDashboard';
